__turbopack_context__.v({
  "down": "reveal-module-scss-module__pkNPuG__down",
  "fade": "reveal-module-scss-module__pkNPuG__fade",
  "inView": "reveal-module-scss-module__pkNPuG__inView",
  "left": "reveal-module-scss-module__pkNPuG__left",
  "reveal": "reveal-module-scss-module__pkNPuG__reveal",
  "right": "reveal-module-scss-module__pkNPuG__right",
  "scale": "reveal-module-scss-module__pkNPuG__scale",
  "up": "reveal-module-scss-module__pkNPuG__up",
});
